import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, EventEmitter, OnInit, QueryList, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LayerApi } from '../../../api/layer-api';
import { UserApi } from '../../../api/user-api';
import { environment } from '../../../environment';
import { InputConverter } from '../../../inputConverter';
import { LayerService } from '../../../services/layer.service';
import { LayerCatalogService } from '../../../services/layerCatalog.service';
import { PetlService } from '../../../services/petl.service';
import { LogLevel } from '../../../types';
import { BaseComponent } from '../../base.component';
var ShareType;
(function (ShareType) {
    ShareType[ShareType["NotShared"] = 0] = "NotShared";
    ShareType[ShareType["SharedBy"] = 1] = "SharedBy";
    ShareType[ShareType["SharedWith"] = 2] = "SharedWith";
})(ShareType || (ShareType = {}));
var LayerCatalogComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LayerCatalogComponent, _super);
    /* tslint:disable:template-cyclomatic-complexity */
    function LayerCatalogComponent(_vcr, authService, _formBuilder, layerCatalogService, layerService, cdr, LoggingService, userApi, layerApi, petlService) {
        var _this = _super.call(this, _vcr) || this;
        _this.authService = authService;
        _this._formBuilder = _formBuilder;
        _this.layerCatalogService = layerCatalogService;
        _this.layerService = layerService;
        _this.cdr = cdr;
        _this.LoggingService = LoggingService;
        _this.userApi = userApi;
        _this.layerApi = layerApi;
        _this.petlService = petlService;
        _this.applicationId = environment.appId;
        _this.externalLayerTabTitle = 'External Layers';
        _this.mergeLayers = false;
        _this.selectedLayers = [];
        _this.filterLayersBeforeAdd = false;
        _this.external = true;
        _this.showMyLayers = true;
        _this.showMyDrawingLayers = true;
        _this._userId = null;
        _this.layersAdded = new EventEmitter();
        _this.openShareLayers = new EventEmitter();
        _this.openUnshareLayers = new EventEmitter();
        _this.currentTabIndex = 0;
        _this.debounceTime = 500;
        _this.filteredSystemLayerCatalogItems = [];
        _this.filteredUserLayerCatalogItems = [];
        _this.filteredUserDrawingLayerCatalogItems = [];
        _this.systemLayerCatalogItems = null;
        _this.userLayerCatalogItems = null;
        _this.userDrawingLayerCatalogItems = null;
        _this.searchInputControl = new FormControl();
        _this.externalShowCatalog = true;
        _this.userLayerFolders = [];
        _this.drawLayerFolders = [];
        _this.folderEditing = false;
        _this.parentFolders = [];
        _this.systemLayerErrorMessage = null;
        _this._active = false;
        _this.layerCatalogItemsSort = function (a, b) {
            var retVal = 0;
            if ((a.displayOrder !== null && a.displayOrder !== undefined) || (b.displayOrder !== null && b.displayOrder !== undefined)) {
                var aOrder = a.displayOrder || 99999;
                var bOrder = b.displayOrder || 99999;
                if (aOrder > bOrder) {
                    retVal = 1;
                }
                else if (aOrder < bOrder) {
                    retVal = -1;
                }
            }
            else if (a.name.toLowerCase() > b.name.toLowerCase()) {
                retVal = 1;
            }
            else if (a.name.toLowerCase() < b.name.toLowerCase()) {
                retVal = -1;
            }
            return retVal;
        };
        _this.searchInputForm = _this._formBuilder.group({
            searchInput: _this.searchInputControl
        });
        return _this;
    }
    Object.defineProperty(LayerCatalogComponent.prototype, "userId", {
        get: function () { return this._userId; },
        set: function (value) {
            this._userId = value;
            this.cdr.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayerCatalogComponent.prototype, "active", {
        get: function () { return this._active; },
        set: function (active) {
            this._active = active;
            if (active) {
                this.activate();
            }
            else {
                this.deactivate();
            }
        },
        enumerable: true,
        configurable: true
    });
    LayerCatalogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.searchInputControl
            .valueChanges
            .pipe(debounceTime(this.debounceTime), distinctUntilChanged()).subscribe(function () {
            if (_this.currentTabIndex === 0) {
                _this.loadFilteredSystemLayerCatalogItems();
                _this.cdr.detectChanges();
            }
            else {
                _this.loadFilteredUserLayerCatalogItems();
            }
        });
        this.userLayerNodes = [];
        this.drawLayerNodes = [];
        this.treeOptions = {};
        this.loading = { status: false, text: 'Loading...' };
        this.newFolderName = new FormControl('', [Validators.required, this.nameInUse.bind(this)]); //tslint:disable-line
    };
    LayerCatalogComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapViewRef)];
                    case 1:
                        _a.mapViewRef = _b.sent();
                        this.isReady();
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogComponent.prototype.addSelectedLayers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userLayerType, petlLayers, layers, addLayers, layerSettings;
            return tslib_1.__generator(this, function (_a) {
                this.refreshSelectedLayers();
                userLayerType = 3;
                if (this.filterLayersBeforeAdd && !this.selectedLayers.some(function (x) { return x.typeId === userLayerType; })) {
                    petlLayers = this.selectedLayers.filter(function (sl) { return sl.isPETL; });
                    if (petlLayers.length) {
                        this.layerService.addMapcoreLayersToMap(petlLayers); // May want to use the PETL service to load these if we want it to overwrite currently loaded PETL layers
                    }
                    layers = this.selectedLayers.filter(function (sl) { return !sl.isPETL; });
                    if (layers.length) {
                        addLayers = new CustomEvent('addingMapcoreLayersToMap', { detail: layers, composed: true });
                        window.dispatchEvent(addLayers);
                    }
                }
                else {
                    layerSettings = this.selectedLayers.map(function (sl) {
                        if (sl.isPETL) {
                            return sl;
                        }
                        return { id: sl.id };
                    });
                    this.layerService.addMapcoreLayersToMap(layerSettings);
                }
                this.layersAdded.emit(true);
                return [2 /*return*/];
            });
        });
    };
    LayerCatalogComponent.prototype.deleteSelectedLayers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.refreshSelectedLayers();
                        return [4 /*yield*/, Promise.all(this.selectedLayers.map(function (l) { return _this.deleteLayer(l, false, true); }))];
                    case 1:
                        _a.sent();
                        this.userLayerCatalogItems = [];
                        this.userDrawingLayerCatalogItems = [];
                        this.selectedLayers = [];
                        return [4 /*yield*/, this.refreshUserLayerCatalog()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogComponent.prototype.clearFilterAndSelected = function () {
        this.selectedLayers = [];
        this.searchText = '';
    };
    LayerCatalogComponent.prototype.filterCatalogItems = function (layerCatalogItems) {
        var e_1, _a;
        var copyOfArray = layerCatalogItems.concat([]);
        var newArray = [];
        try {
            for (var copyOfArray_1 = tslib_1.__values(copyOfArray), copyOfArray_1_1 = copyOfArray_1.next(); !copyOfArray_1_1.done; copyOfArray_1_1 = copyOfArray_1.next()) {
                var layerCatalogItem = copyOfArray_1_1.value;
                var currentItem = null;
                if (layerCatalogItem.layer) {
                    currentItem = layerCatalogItem;
                }
                else {
                    currentItem = tslib_1.__assign({}, layerCatalogItem);
                }
                if ((currentItem.layer && currentItem.layer.id.toString() === this.searchText)
                    || (currentItem.isSelected || !this.searchText || this.isMatchToSearchText(currentItem.name, currentItem.layer ? currentItem.layer.description : null))) {
                    newArray.push(currentItem);
                }
                if (currentItem.layerCatalogItems) {
                    if (newArray.indexOf(currentItem) < 0) {
                        currentItem.layerCatalogItems = this.filterCatalogItems(currentItem.layerCatalogItems);
                        if (this.searchText) {
                            currentItem.expanded = currentItem.layerCatalogItems.length > 0;
                        }
                    }
                }
                if (newArray.indexOf(currentItem) < 0 && currentItem.layerCatalogItems && currentItem.layerCatalogItems.length > 0) {
                    newArray.push(currentItem);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (copyOfArray_1_1 && !copyOfArray_1_1.done && (_a = copyOfArray_1.return)) _a.call(copyOfArray_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return newArray;
    };
    LayerCatalogComponent.prototype.getSelectedLayers = function (layerCatalogItems) {
        var e_2, _a;
        var layers = [];
        try {
            for (var layerCatalogItems_1 = tslib_1.__values(layerCatalogItems), layerCatalogItems_1_1 = layerCatalogItems_1.next(); !layerCatalogItems_1_1.done; layerCatalogItems_1_1 = layerCatalogItems_1.next()) {
                var layerCatalogItem = layerCatalogItems_1_1.value;
                if (layerCatalogItem.layer && layerCatalogItem.isSelected) {
                    if (layerCatalogItem.ispetl) {
                        layers.push(this.petlService.getProjectLayerSettings({ id: layerCatalogItem.id, description: layerCatalogItem.name }));
                    }
                    else {
                        layers.push(layerCatalogItem.layer);
                    }
                }
                else if (layerCatalogItem.layerCatalogItems) {
                    layers.push.apply(layers, tslib_1.__spread(this.getSelectedLayers(layerCatalogItem.layerCatalogItems)));
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (layerCatalogItems_1_1 && !layerCatalogItems_1_1.done && (_a = layerCatalogItems_1.return)) _a.call(layerCatalogItems_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return layers;
    };
    LayerCatalogComponent.prototype.itemSelectedChanged = function (layerCatalogItems) {
        if (layerCatalogItems && layerCatalogItems.name && layerCatalogItems.isSelected !== undefined) {
            if (this.userLayerCatalogItems && this.currentTabIndex === 1) {
                var selectedLayerIndex = this.userLayerCatalogItems.findIndex(function (x) { return x.layer.id === layerCatalogItems.layer.id; });
                if (selectedLayerIndex !== null) {
                    this.userLayerCatalogItems[selectedLayerIndex].isSelected = layerCatalogItems.isSelected;
                }
            }
            else if (this.userDrawingLayerCatalogItems && this.currentTabIndex === 2) {
                var selectedLayerIndex = this.userDrawingLayerCatalogItems.findIndex(function (x) { return x.layer.id === layerCatalogItems.layer.id; });
                if (selectedLayerIndex !== null) {
                    this.userDrawingLayerCatalogItems[selectedLayerIndex].isSelected = layerCatalogItems.isSelected;
                }
            }
        }
        this.refreshSelectedLayers();
    };
    LayerCatalogComponent.prototype.isMatchToSearchText = function (name, description) {
        var e_3, _a, e_4, _b;
        var nameLower = name.toLowerCase();
        var searchTextLower = this.searchText.toLowerCase();
        var searchTermArray = searchTextLower.split(' ');
        var allTermsFoundName = true;
        try {
            for (var searchTermArray_1 = tslib_1.__values(searchTermArray), searchTermArray_1_1 = searchTermArray_1.next(); !searchTermArray_1_1.done; searchTermArray_1_1 = searchTermArray_1.next()) {
                var term = searchTermArray_1_1.value;
                allTermsFoundName = allTermsFoundName && nameLower.indexOf(term) >= 0;
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (searchTermArray_1_1 && !searchTermArray_1_1.done && (_a = searchTermArray_1.return)) _a.call(searchTermArray_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        var allTermsFoundDesc = false;
        if (description) {
            var descLower = description.toLowerCase();
            allTermsFoundDesc = true;
            try {
                for (var searchTermArray_2 = tslib_1.__values(searchTermArray), searchTermArray_2_1 = searchTermArray_2.next(); !searchTermArray_2_1.done; searchTermArray_2_1 = searchTermArray_2.next()) {
                    var term = searchTermArray_2_1.value;
                    allTermsFoundDesc = allTermsFoundDesc && descLower.indexOf(term) >= 0;
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (searchTermArray_2_1 && !searchTermArray_2_1.done && (_b = searchTermArray_2.return)) _b.call(searchTermArray_2);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        return allTermsFoundName || allTermsFoundDesc;
    };
    LayerCatalogComponent.prototype.getFilteredCatalogItems = function (fullList) {
        var _this = this;
        if (fullList) {
            var filteredItems = this.filterCatalogItems(fullList);
            var sortLevel_1 = function (level) {
                var e_5, _a;
                try {
                    for (var level_1 = tslib_1.__values(level), level_1_1 = level_1.next(); !level_1_1.done; level_1_1 = level_1.next()) {
                        var catalogItem = level_1_1.value;
                        if (catalogItem.layerCatalogItems) {
                            catalogItem.layerCatalogItems = sortLevel_1(catalogItem.layerCatalogItems);
                        }
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (level_1_1 && !level_1_1.done && (_a = level_1.return)) _a.call(level_1);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
                return level.sort(_this.layerCatalogItemsSort);
            };
            return sortLevel_1(filteredItems);
        }
        else {
            return [];
        }
    };
    LayerCatalogComponent.prototype.loadFilteredSystemLayerCatalogItems = function () {
        this.filteredSystemLayerCatalogItems = this.getFilteredCatalogItems(this.systemLayerCatalogItems);
    };
    LayerCatalogComponent.prototype.loadFilteredUserLayerCatalogItems = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.filteredUserLayerCatalogItems = this.getFilteredCatalogItems(this.userLayerCatalogItems);
                        this.filteredUserDrawingLayerCatalogItems = this.getFilteredCatalogItems(this.userDrawingLayerCatalogItems);
                        if (!(this.currentTabIndex === 1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setTree(this.userLayerFolders, this.filteredUserLayerCatalogItems)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(this.currentTabIndex === 2)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.setTree(this.drawLayerFolders, this.filteredUserDrawingLayerCatalogItems)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.treeOptions = {};
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogComponent.prototype.refreshSelectedLayers = function () {
        var systemAndUserItems = [];
        if (this.systemLayerCatalogItems) {
            systemAndUserItems = systemAndUserItems.concat(this.systemLayerCatalogItems);
        }
        if (this.userLayerCatalogItems) {
            systemAndUserItems = systemAndUserItems.concat(this.userLayerCatalogItems);
        }
        if (this.userDrawingLayerCatalogItems) {
            systemAndUserItems = systemAndUserItems.concat(this.userDrawingLayerCatalogItems);
        }
        this.selectedLayers = [];
        this.selectedLayers = this.getSelectedLayers(systemAndUserItems);
        this.cdr.detectChanges();
    };
    LayerCatalogComponent.prototype.deactivate = function () {
        if (this.externalLayerCatalogRef) {
            this.externalLayerCatalogRef.active = false;
        }
        this.clearFilterAndSelected();
        this.filteredSystemLayerCatalogItems = [];
        this.filteredUserLayerCatalogItems = [];
        this.filteredUserDrawingLayerCatalogItems = [];
        this.externalShowCatalog = true;
        this.currentTabIndex = 0;
    };
    LayerCatalogComponent.prototype.activate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = { status: true, text: 'Loading...' };
                        if (!!this.userSubscriber) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.authService.GetCurrentUser().subscribe(function (user) {
                                if (user && user.id) {
                                    _this.userId = user.id;
                                }
                                else {
                                    _this.userId = null;
                                }
                            })];
                    case 1:
                        _a.userSubscriber = _b.sent();
                        _b.label = 2;
                    case 2:
                        this.systemLayerCatalogItems = [];
                        this.userLayerCatalogItems = [];
                        this.userDrawingLayerCatalogItems = [];
                        this.selectedLayers = [];
                        return [4 /*yield*/, this.layerCatalogService.generateCatalog(environment.appId).then(function (data) {
                                _this.systemLayerCatalogItems = data;
                                _this.loadFilteredSystemLayerCatalogItems();
                            })];
                    case 3:
                        _b.sent();
                        if (!this.userId) return [3 /*break*/, 6];
                        if (!(this.currentTabIndex !== 0)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.updateLayerFolders()];
                    case 4:
                        _b.sent();
                        return [4 /*yield*/, this.refreshUserLayerCatalog()];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        this.loading.status = false;
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogComponent.prototype.refreshUserLayerCatalog = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_6, _a, items, items_1, items_1_1, item;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.userId) return [3 /*break*/, 3];
                        this.userLayerCatalogItems = [];
                        this.userDrawingLayerCatalogItems = [];
                        return [4 /*yield*/, this.layerCatalogService.getUserLayerCatalog(this.userId)];
                    case 1:
                        items = _b.sent();
                        try {
                            for (items_1 = tslib_1.__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                                item = items_1_1.value;
                                if ((item.layer.sources && item.layer.sources.length > 0) && item.layer.sources.filter(function (x) { return x.sourceType === 'DRAWING_DATA'; }).length > 0) {
                                    item.id = item.layer.id;
                                    this.userDrawingLayerCatalogItems.push(item);
                                }
                                else {
                                    this.userLayerCatalogItems.push(item);
                                }
                            }
                        }
                        catch (e_6_1) { e_6 = { error: e_6_1 }; }
                        finally {
                            try {
                                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                            }
                            finally { if (e_6) throw e_6.error; }
                        }
                        return [4 /*yield*/, this.loadFilteredUserLayerCatalogItems()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogComponent.prototype.onTabSelect = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sub_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        //refresh folders and layers
                        this.currentTabIndex = e.index;
                        if (!(this.currentTabIndex !== 0)) return [3 /*break*/, 3];
                        this.loading = { status: true, text: 'Loading...' };
                        if (!(e.title !== this.externalLayerTabTitle)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.updateLayerFolders()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.refreshUserLayerCatalog()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (this.external) {
                            sub_1 = this.externalLayerCatalog.changes.subscribe(function (ql) {
                                sub_1.unsubscribe();
                                _this.externalLayerCatalogRef = ql.first;
                                if (_this.externalLayerCatalogRef) {
                                    _this.externalLayerCatalogRef.active = e.title === _this.externalLayerTabTitle;
                                }
                            });
                        }
                        this.loading.status = false;
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogComponent.prototype.addFolder = function (folder) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layerType, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.currentFolderId = null;
                        this.parentFolderId = folder ? folder.id : undefined;
                        layerType = this.currentTabIndex === 1 ? 'layers' : 'drawing-layers';
                        _a = this;
                        return [4 /*yield*/, this.userApi.queryUserFolders(this.userId, this.applicationId, layerType)];
                    case 1:
                        _a.parentFolders = _b.sent();
                        this.parentFolders.push({ name: 'No parent', id: 0 });
                        this.showFolderEditor = true;
                        this.newFolderName.setValue('');
                        this.folderEditing = false;
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogComponent.prototype.nameInUse = function (control) {
        var _this = this;
        var parentFolder = this.parentFolders.find(function (f) { return f.id === _this.currentFolderId; });
        if (this.currentFolderId && (!parentFolder || control.value === parentFolder.name)) {
            return null;
        }
        return this.parentFolders
            .map(function (f) { return f.name; })
            .includes(control.value) ? { nameInUse: { value: control.value } } : null;
    };
    LayerCatalogComponent.prototype.editFolder = function (folder) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var parentFolder, layerType, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.currentFolderId = folder.id;
                        parentFolder = this.parentFolders.find(function (f) { return f.id === folder.id; });
                        this.parentFolderId = parentFolder ? parentFolder.parentUserFolderId : null;
                        layerType = this.currentTabIndex === 1 ? 'layers' : 'drawing-layers';
                        _a = this;
                        return [4 /*yield*/, this.userApi.queryUserFolders(this.userId, this.applicationId, layerType)];
                    case 1:
                        _a.parentFolders = _b.sent();
                        this.parentFolders.push({ name: 'No parent', id: 0 });
                        this.newFolderName.setValue(folder.name);
                        this.showFolderEditor = true;
                        this.folderEditing = true;
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogComponent.prototype.newFolder = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layerType, folder, _a, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        layerType = this.currentTabIndex === 1 ? 'layers' : 'drawing-layers';
                        folder = {
                            name: this.newFolderName.value,
                            category: layerType,
                            parentUserFolderId: this.parentFolderId,
                            userId: this.userId,
                            applicationId: this.applicationId
                        };
                        if (this.currentFolderId) {
                            folder.id = this.currentFolderId;
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, 5, 8]);
                        this.showFolderEditor = false;
                        this.loading = { status: true, text: 'Creating new folder...' };
                        return [4 /*yield*/, this.userApi.createNewUserFolder(folder)];
                    case 2:
                        _b.sent();
                        _a = this;
                        return [4 /*yield*/, this.userApi.queryUserFolders(this.userId, this.applicationId, layerType)];
                    case 3:
                        _a.parentFolders = _b.sent();
                        this.parentFolders.push({ name: 'No parent', id: 0 });
                        return [3 /*break*/, 8];
                    case 4:
                        error_1 = _b.sent();
                        this.LoggingService.Log(error_1, LogLevel.Error);
                        return [3 /*break*/, 8];
                    case 5: 
                    //refresh folders and layers
                    return [4 /*yield*/, this.updateLayerFolders()];
                    case 6:
                        //refresh folders and layers
                        _b.sent();
                        return [4 /*yield*/, this.refreshUserLayerCatalog()];
                    case 7:
                        _b.sent();
                        this.loading.status = false;
                        this.cdr.detectChanges();
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogComponent.prototype.setTree = function (userLayersFolders, userLayers) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userLayerNodesTemp;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.userLayerNodes = [];
                        this.drawLayerNodes = [];
                        userLayerNodesTemp = [];
                        this.loading = { status: true, text: 'Building Nodes...' };
                        if (userLayersFolders) {
                            userLayersFolders.sort(function (a, b) { return a.name.localeCompare(b.name); });
                            userLayers.sort(function (a, b) { return a.layer.name.localeCompare(b.layer.name); });
                            userLayerNodesTemp.push.apply(userLayerNodesTemp, tslib_1.__spread(userLayersFolders.filter(function (f) { return !f.parentUserFolderId || f.parentUserFolderId === 0; }).map(function (f) { return _this.buildTreeNode(f, userLayersFolders, userLayers); })));
                        }
                        // Add orphan layers
                        userLayerNodesTemp.push.apply(userLayerNodesTemp, tslib_1.__spread(userLayers.map(function (l) {
                            var layerObj = l.layer;
                            layerObj.sharedWith = l.sharedWith || [];
                            return {
                                children: [],
                                id: l.layer.id,
                                layer: l.layer,
                                name: l.layer.name,
                                nodeType: 'leaf',
                                owner: _this.isOwner(l)
                            };
                        })));
                        return [4 /*yield*/, this.updateNodesIsShared(userLayerNodesTemp)];
                    case 1:
                        _a.sent();
                        this.loading.status = false;
                        if (this.currentTabIndex === 1) {
                            this.userLayerNodes = userLayerNodesTemp;
                        }
                        else if (this.currentTabIndex === 2) {
                            this.drawLayerNodes = userLayerNodesTemp;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogComponent.prototype.buildTreeNode = function (folder, userfolders, userLayers) {
        var _this = this;
        var _a, _b;
        var childFolders = userfolders.filter(function (f) { return f.parentUserFolderId === folder.id; });
        var childLayers = this.getChildLayers(folder, userLayers);
        var groupNode = {
            children: [],
            id: folder.id,
            name: folder.name,
            nodeType: 'group'
        };
        (_a = groupNode.children).push.apply(_a, tslib_1.__spread(childLayers.map(function (l) {
            l.layer.sharedWith = l.sharedWith;
            return {
                children: [],
                id: l.layer.id,
                layer: l.layer,
                name: l.layer.name,
                nodeType: 'leaf',
                owner: _this.isOwner(l)
            };
        })));
        (_b = groupNode.children).push.apply(_b, tslib_1.__spread(childFolders.map(function (cf) { return _this.buildTreeNode(cf, userfolders, userLayers); })));
        return groupNode;
    };
    LayerCatalogComponent.prototype.getChildLayers = function (folder, userLayers) {
        var childLayers = [];
        folder.layers.forEach(function (fl) {
            var userLayer = userLayers.find(function (ul) { return ul.layer.id === fl.id; });
            if (userLayer) {
                childLayers.push(userLayer);
                var idx = userLayers.indexOf(userLayer);
                userLayers.splice(idx, 1);
            }
        });
        childLayers.sort(function (a, b) { return a.layer.name.localeCompare(b.layer.name); });
        return childLayers;
    };
    LayerCatalogComponent.prototype.isOwner = function (layerMetaData) {
        var _this = this;
        var retVal = true;
        if (layerMetaData.layer && layerMetaData.layer.userLayers) {
            var shareData = layerMetaData.layer.userLayers.find(function (ul) { return ul.userId === _this.userId; });
            if (shareData) {
                retVal = shareData.accessLevel === 'OWNER';
            }
        }
        return retVal;
    };
    LayerCatalogComponent.prototype.pickFolder = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var parentFolder, layerType, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.currentLayerId = layer.id;
                        parentFolder = this.userLayerFolders.find(function (f) { return f.layers.find(function (l) { return l.id === layer.id; }); });
                        if (parentFolder) {
                            this.parentFolderId = parentFolder.id;
                        }
                        layerType = this.currentTabIndex === 1 ? 'layers' : 'drawing-layers';
                        _a = this;
                        return [4 /*yield*/, this.userApi.queryUserFolders(this.userId, this.applicationId, layerType)];
                    case 1:
                        _a.parentFolders = _b.sent();
                        this.parentFolders.push({ name: 'No parent', id: 0 });
                        this.showFolderPicker = true;
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogComponent.prototype.changeFolder = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.showFolderPicker = false;
                        this.loading = { status: true, text: 'Changing folder...' };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 7]);
                        return [4 /*yield*/, this.layerService.saveLayerToUserFolder(this.currentLayerId, this.parentFolderId)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 3:
                        error_2 = _a.sent();
                        this.LoggingService.Log(error_2, LogLevel.Error);
                        return [3 /*break*/, 7];
                    case 4: 
                    //refresh folders and layers
                    return [4 /*yield*/, this.updateLayerFolders()];
                    case 5:
                        //refresh folders and layers
                        _a.sent();
                        return [4 /*yield*/, this.refreshUserLayerCatalog()];
                    case 6:
                        _a.sent();
                        this.loading.status = false;
                        this.cdr.detectChanges();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogComponent.prototype.deleteFolder = function (folder) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!window.confirm('Are you sure you want to delete this folder and all layers it contains?')) return [3 /*break*/, 7];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 7]);
                        this.loading = { status: true, text: 'Deleting Folder...' };
                        return [4 /*yield*/, this.deleteFolderAndLayers(folder)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 3:
                        error_3 = _a.sent();
                        this.LoggingService.Log(error_3, LogLevel.Error);
                        return [3 /*break*/, 7];
                    case 4:
                        this.parentFolders = this.parentFolders.filter(function (f) { return f.id !== folder.id; });
                        //refresh folders and layers
                        return [4 /*yield*/, this.updateLayerFolders()];
                    case 5:
                        //refresh folders and layers
                        _a.sent();
                        return [4 /*yield*/, this.refreshUserLayerCatalog()];
                    case 6:
                        _a.sent();
                        this.loading.status = false;
                        this.cdr.detectChanges();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogComponent.prototype.deleteFolderAndLayers = function (folder) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_7, _a, _b, _c, child, e_7_1;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 7, 8, 9]);
                        _b = tslib_1.__values(folder.children), _c = _b.next();
                        _d.label = 1;
                    case 1:
                        if (!!_c.done) return [3 /*break*/, 6];
                        child = _c.value;
                        if (!(child.nodeType === 'group')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.deleteFolderAndLayers(child)];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.deleteLayer(child, false)];
                    case 4:
                        _d.sent();
                        if (child.id === this.mapViewRef.mapcoreViewProps.id) {
                            this.resetMap();
                        }
                        _d.label = 5;
                    case 5:
                        _c = _b.next();
                        return [3 /*break*/, 1];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_7_1 = _d.sent();
                        e_7 = { error: e_7_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_7) throw e_7.error; }
                        return [7 /*endfinally*/];
                    case 9: return [4 /*yield*/, this.userApi.deleteUserFolder(folder.id)];
                    case 10:
                        _d.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogComponent.prototype.resetMap = function () {
        this.mapViewRef.mapcoreViewProps.id = null;
        if (this.mapViewRef.mapcoreViewProps.layers) {
            this.mapViewRef.mapcoreViewProps.layers.forEach(function (layer) {
                layer.id = null;
            });
        }
    };
    LayerCatalogComponent.prototype.deleteLayer = function (layer, askQuestion, multiple) {
        if (askQuestion === void 0) { askQuestion = true; }
        if (multiple === void 0) { multiple = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 13, 14, 18]);
                        return [4 /*yield*/, this.getLayerSharedType(layer)];
                    case 1:
                        if (!((_a.sent()) !== ShareType.SharedWith)) return [3 /*break*/, 7];
                        if (!askQuestion) return [3 /*break*/, 4];
                        if (!window.confirm('Are you sure you want to delete layer?')) return [3 /*break*/, 3];
                        this.loading = { status: true, text: 'Deleting Folder...' };
                        return [4 /*yield*/, this.layerService.deletelayer(layer.id)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4:
                        this.loading = { status: true, text: 'Deleting Folder...' };
                        return [4 /*yield*/, this.layerService.deletelayer(layer.id)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [3 /*break*/, 12];
                    case 7:
                        if (!askQuestion) return [3 /*break*/, 10];
                        if (!window.confirm('Are you sure you want to no longer have this layer shared with you?')) return [3 /*break*/, 9];
                        this.loading = { status: true, text: 'Removing Shared Layer Association...' };
                        /* remove shared layer association */
                        return [4 /*yield*/, this.layerApi.unshareLayer([this.userId], layer.id)];
                    case 8:
                        /* remove shared layer association */
                        _a.sent();
                        _a.label = 9;
                    case 9: return [3 /*break*/, 12];
                    case 10:
                        this.loading = { status: true, text: 'Removing Shared Layer Association...' };
                        /* remove shared layer association */
                        return [4 /*yield*/, this.layerApi.unshareLayer([this.userId], layer.id)];
                    case 11:
                        /* remove shared layer association */
                        _a.sent();
                        _a.label = 12;
                    case 12:
                        if (layer.id === this.mapViewRef.mapcoreViewProps.id) {
                            this.resetMap();
                        }
                        return [3 /*break*/, 18];
                    case 13:
                        error_4 = _a.sent();
                        this.LoggingService.Log(error_4, LogLevel.Error);
                        return [3 /*break*/, 18];
                    case 14:
                        if (!!multiple) return [3 /*break*/, 17];
                        //refresh folders and layers
                        return [4 /*yield*/, this.updateLayerFolders()];
                    case 15:
                        //refresh folders and layers
                        _a.sent();
                        return [4 /*yield*/, this.refreshUserLayerCatalog()];
                    case 16:
                        _a.sent();
                        this.loading.status = false;
                        this.cdr.detectChanges();
                        _a.label = 17;
                    case 17: return [7 /*endfinally*/];
                    case 18: return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogComponent.prototype.shareLayer = function (layer) {
        this.openShareLayers.emit(layer.id);
    };
    LayerCatalogComponent.prototype.unshareLayer = function (layer) {
        this.openUnshareLayers.emit(layer.id);
    };
    LayerCatalogComponent.prototype.updateLayerFolders = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layerType, _a, _b, _c;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!this.userId) return [3 /*break*/, 5];
                        layerType = this.currentTabIndex === 1 ? 'layers' : 'drawing-layers';
                        _a = this;
                        return [4 /*yield*/, this.userApi.queryUserFolders(this.userId, this.applicationId, layerType)];
                    case 1:
                        _a.parentFolders = _d.sent();
                        this.parentFolders.push({ name: 'No parent', id: 0 });
                        if (!(this.currentTabIndex === 1)) return [3 /*break*/, 3];
                        _b = this;
                        return [4 /*yield*/, this.layerService.getUserLayersFolders(this.userId, this.applicationId)];
                    case 2:
                        _b.userLayerFolders = (_d.sent())[0].folders;
                        return [3 /*break*/, 5];
                    case 3:
                        if (!(this.currentTabIndex === 2)) return [3 /*break*/, 5];
                        _c = this;
                        return [4 /*yield*/, this.layerService.getDrawLayersFolders(this.userId, this.applicationId)];
                    case 4:
                        _c.drawLayerFolders = (_d.sent())[0].folders;
                        _d.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /* Returns the number of users a given layer is shared with */
    LayerCatalogComponent.prototype.getLayerSharedType = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var retVal, layers, userLayers, userLevel;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        retVal = ShareType.NotShared;
                        return [4 /*yield*/, this.layerApi.getUserLayers(layer.id)];
                    case 1:
                        layers = _a.sent();
                        if (layers.length > 0) {
                            userLayers = layers[0].userLayers;
                            if (userLayers.length > 1) {
                                userLevel = userLayers.find(function (ul) { return ul.userId === _this.userId; });
                                if (userLevel.accessLevel === 'OWNER') {
                                    retVal = ShareType.SharedBy;
                                }
                                else {
                                    retVal = ShareType.SharedWith;
                                }
                            }
                        }
                        return [2 /*return*/, retVal];
                }
            });
        });
    };
    LayerCatalogComponent.prototype.updateNodesIsShared = function (nodes) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(nodes.map(function (node) { return _this.checkIfNodeIsShared(node); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /* Iterate through nodes recursively, if the node is a layer, then set its isShared property.
     * The isShared property is used to display/hide unshare-layer button. */
    LayerCatalogComponent.prototype.checkIfNodeIsShared = function (node) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_8, _a, _b, _c, _d, childNode;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!node.layer) return [3 /*break*/, 2];
                        _b = node;
                        return [4 /*yield*/, this.getLayerSharedType(node.layer)];
                    case 1:
                        _b.shareType = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (node.children) {
                            try {
                                for (_c = tslib_1.__values(node.children), _d = _c.next(); !_d.done; _d = _c.next()) {
                                    childNode = _d.value;
                                    this.checkIfNodeIsShared(childNode);
                                }
                            }
                            catch (e_8_1) { e_8 = { error: e_8_1 }; }
                            finally {
                                try {
                                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                                }
                                finally { if (e_8) throw e_8.error; }
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LayerCatalogComponent.prototype.catalogTrack = function (item) {
        return item.id;
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], LayerCatalogComponent.prototype, "mergeLayers", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], LayerCatalogComponent.prototype, "filterLayersBeforeAdd", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], LayerCatalogComponent.prototype, "external", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], LayerCatalogComponent.prototype, "showMyLayers", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], LayerCatalogComponent.prototype, "showMyDrawingLayers", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean),
        tslib_1.__metadata("design:paramtypes", [Boolean])
    ], LayerCatalogComponent.prototype, "active", null);
    return LayerCatalogComponent;
}(BaseComponent));
export { LayerCatalogComponent };
